import { render } from "./CardWrapper.vue?vue&type=template&id=58d1265c"
import script from "./CardWrapper.vue?vue&type=script&lang=js"
export * from "./CardWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CardWrapper.vue"]])

export default __exports__